import { Style } from 'ol/style';
import { useContext } from 'react'
import { connect } from 'react-redux';
import MapContext from "../Map/MapContext";

function GestionAffichageCouches({ listecontenu }) {

    const { map } = useContext(MapContext);


    if (!map) return null;
    map.getLayers().forEach(element => {
        if (element.getProperties().type === "CINEMA") {
            element.getSource().getFeatures().forEach(feature => {
                const thematique = feature.getProperties().thematique;
                const config = Object.values(listecontenu).filter(a => a.thematique === thematique);
                if (config.length > 0 && config[0].afficher) {
                    feature.setStyle();
                }
                else {
                    feature.setStyle(new Style({}));

                }
            })
        }
    });

    return (
        null
    )
}

function mapStateToProps(state) {
    return {
        listecontenu: state.contenu
    }
}

export default connect(mapStateToProps, null)(GestionAffichageCouches);